import { createContext, ReactNode, useCallback, useState } from "react";

type ModalContextType = {
  modal: ReactNode | null;
  open: (modal: ReactNode) => void;
  close: () => void;
}

const INITIAL_STATE = { modal: null, open: () => {}, close: () => {} };

export const ModalContext = createContext<ModalContextType>(INITIAL_STATE);

export const useModalContext = () => {
  const [modal, setModal] = useState<ReactNode>(null);

  const open = useCallback((modal: ReactNode) => {
    setModal(modal);
  }, []);

  const close = useCallback(() => {
    setModal(null);
  }, []);

  return {
    modal,
    open,
    close,
  };
}
